import './_video-block-styles.scss';

document.addEventListener( 'DOMContentLoaded', () => {

	document.querySelectorAll( '.b-video-block' ).forEach( ( block ) => {

		/**
		 * Pause the video and rewind it to the beginning.
		 *
		 * @param {HTMLVideoElement} video Video element to reset.
		 * @return {void}
		 */
		const resetVideo = ( video ) => {

			try {

				video.pause();
				video.currentTime = 0;

			} catch ( e ) {
				// ignore
			}

		};

		const select = block.querySelector( '.js-select-video' );
		if ( !select ) {

			return;

		}

		const wrap = select.closest( '.b-video-block__select-wrap' );
		const videoTabs = block.querySelectorAll( '.b-video-tab' );

		// Save original iframe src so we can restore it when a tab is shown again.
		block.querySelectorAll( 'iframe' ).forEach( ( iframe ) => {

			if ( typeof iframe.dataset.origSrc === 'undefined' ) {

				iframe.dataset.origSrc = iframe.src || '';

			}

		} );

		/**
		 * Show only the tab matching the given tabId, hide the rest.
		 *
		 * @param {string} tabId Value matching data-tab-id attribute.
		 */
		const showTab = ( tabId ) => {

			videoTabs.forEach( ( tab ) => {

				const isActive = tab.dataset.tabId === tabId;

				if ( isActive ) {

					tab.querySelectorAll( 'video' ).forEach( ( video ) => {

						resetVideo( video );

					} );

					tab.querySelectorAll( 'iframe' ).forEach( ( iframe ) => {

						if ( iframe.dataset.origSrc && !iframe.src ) {

							iframe.src = iframe.dataset.origSrc;

						}

					} );

				} else {

					tab.querySelectorAll( 'video' ).forEach( ( video ) => {

						resetVideo( video );

					} );
					tab.querySelectorAll( 'iframe' ).forEach( ( iframe ) => {

						if ( typeof iframe.dataset.origSrc === 'undefined' ) {

							iframe.dataset.origSrc = iframe.src || '';

						}
						if ( iframe.src ) {

							block.querySelectorAll( 'video' ).forEach( ( video ) => {

								resetVideo( video );

							} );

							iframe.src = '';

						}

					} );

				}

				tab.classList.toggle( 'is-hidden', !isActive );

			} );

		};

		// Show first tab on load.
		if ( select.options.length > 0 ) {

			showTab( select.options[ 0 ].value );

		}

		select.addEventListener( 'change', () => {

			showTab( select.value );
			select.blur();

		} );

		// Toggle select-open class on wrapper for arrow rotation.
		if ( wrap ) {

			select.addEventListener( 'focus', () => wrap.classList.add( 'select-open' ) );
			select.addEventListener( 'blur', () => wrap.classList.remove( 'select-open' ) );

		}

	} );

} );
